import { Checkbox, FormGroup, FormControlLabel } from "@mui/material";
import PropTypes from "prop-types";

const CustomCheckbox = ({
  title,
  checked = false,
  onChange,
  fontSize = 12,
  labelStyles = {},
  checkboxStyles = {},
  onFocus,
  onClick,
  size,
}) => {
  const resolvedSize =
    size === "small" || size === "medium" ? size : "small";

  const labelText =
    typeof title === "string" ? title : title == null ? "" : String(title);

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            size={resolvedSize}
            style={checkboxStyles}
            sx={{
              paddingBlock: "2px",
              color: "#BAB7B7",
              "&.Mui-checked": { color: "#61D5A9" },
              "& .MuiSvgIcon-root": { height: "14px", width: "14px" },
            }}
            onFocus={onFocus}
            onChange={onChange}
            onClick={onClick}
            checked={checked}
          />
        }
        sx={{
          alignItems: "flex-start",
          "& .MuiFormControlLabel-label": {
            color: "black",
            fontSize,
            ...labelStyles,
          },
        }}
        label={labelText}
      />
    </FormGroup>
  );
};

CustomCheckbox.propTypes = {
  title: PropTypes.any,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  fontSize: PropTypes.number,
  labelStyles: PropTypes.object,
  checkboxStyles: PropTypes.object,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  size: PropTypes.any,
};

export default CustomCheckbox;
